import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const safeString = (value, fallback = '') => (typeof value === 'string' ? value : fallback);

function CampaignListModal({ open, campaigns, activeCampaignId, onClose, onView, onDelete, onClearAll }) {
  const safeCampaigns = Array.isArray(campaigns) ? campaigns : [];

  return (
    <Dialog
      className="ky-list-modal"
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        className: 'ky-list-dialog-paper',
        sx: {
          background: 'linear-gradient(180deg, #fffaf0 0%, #f3eadb 100%)',
          border: '1px solid rgba(151,113,39,0.24)',
          borderRadius: 2,
          color: '#2f2516',
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle sx={{ px: 1.6, py: 1.2, borderBottom: '1px solid rgba(151,113,39,0.14)' }}>
        <Typography sx={{ color: '#2f2516', fontWeight: 900, fontSize: '1.18rem' }}>Kampanyalar</Typography>
        <Typography sx={{ color: '#6b5b40', fontSize: '0.82rem', mt: 0.2 }}>
          Oluşturulan kampanyaları görüntüle veya temizle
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 1.4, maxHeight: '68vh', overflowY: 'auto', overflowX: 'hidden', bgcolor: '#f8f1e3' }}>
        <Box sx={{ display: 'grid', gap: 0.8 }}>
          {safeCampaigns.length ? (
            safeCampaigns.map((campaign) => {
              const isActive = activeCampaignId === campaign.id;
              return (
                <Box
                  key={campaign.id}
                  className="ky-list-item"
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: 'minmax(0, 1fr) 170px' },
                    gap: 1,
                    alignItems: 'center',
                    border: `1px solid ${isActive ? 'rgba(151,113,39,0.48)' : 'rgba(151,113,39,0.16)'}`,
                    borderRadius: 1.6,
                    p: 1,
                    bgcolor: isActive ? 'rgba(151,113,39,0.11)' : 'rgba(255,255,255,0.72)',
                    boxShadow: isActive ? '0 8px 18px rgba(151,113,39,0.12)' : 'none'
                  }}
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ color: '#2f2516', fontSize: '0.98rem', fontWeight: 900, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {safeString(campaign.name, 'Yeni Kampanya')}
                    </Typography>
                    <Typography sx={{ color: '#5f5140', fontSize: '0.82rem', mt: 0.25 }}>
                      {safeString(campaign.start, '-')} - {safeString(campaign.end, '-')}
                    </Typography>
                    {safeString(campaign.createdAt) ? (
                      <Typography sx={{ color: '#7a6b55', fontSize: '0.72rem', mt: 0.2 }}>
                        Oluşturulma: {safeString(campaign.createdAt)}
                      </Typography>
                    ) : null}
                  </Box>
                  <Box className="ky-list-actions" sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-end' }, gap: 0.6 }}>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => onView(campaign)}
                      sx={{ textTransform: 'none', color: '#7a4d0b', borderColor: 'rgba(151,113,39,0.34)' }}
                    >
                      Görüntüle
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => onDelete(campaign)}
                      sx={{
                        textTransform: 'none',
                        color: '#dc2626',
                        borderColor: '#dc2626',
                        fontWeight: 900,
                        '&:hover': { borderColor: '#b91c1c', bgcolor: 'rgba(220,38,38,0.08)' }
                      }}
                    >
                      Sil
                    </Button>
                  </Box>
                </Box>
              );
            })
          ) : (
            <Box sx={{ border: '1px dashed rgba(151,113,39,0.24)', borderRadius: 1.6, p: 2, textAlign: 'center', bgcolor: 'rgba(255,255,255,0.62)' }}>
              <Typography sx={{ color: '#5f5140', fontSize: '0.92rem' }}>Henüz kayıtlı kampanya yok.</Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions className="ky-list-dialog-actions" sx={{ px: 1.6, py: 1, borderTop: '1px solid rgba(151,113,39,0.14)', bgcolor: 'rgba(255,250,240,0.96)' }}>
        <Button className="ky-list-clear-btn" onClick={onClearAll} sx={{ mr: 'auto', textTransform: 'none', color: '#dc2626', fontWeight: 900 }}>
          Tüm kampanya verilerini temizle
        </Button>
        <Button onClick={onClose} sx={{ textTransform: 'none', color: '#4b5563' }}>Kapat</Button>
      </DialogActions>
      <style>{`
        @media (max-width: 600px) {
          .ky-list-dialog-paper {
            width: calc(100vw - 8px) !important;
            max-width: calc(100vw - 8px) !important;
            margin: 4px !important;
            max-height: calc(100svh - 8px) !important;
          }

          .ky-list-item {
            grid-template-columns: 1fr !important;
            gap: 8px !important;
          }

          .ky-list-actions {
            width: 100% !important;
            display: grid !important;
            grid-template-columns: 1fr 1fr !important;
            gap: 6px !important;
          }

          .ky-list-actions .MuiButton-root {
            width: 100% !important;
            min-height: 38px !important;
          }

          .ky-list-dialog-actions {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 6px !important;
          }

          .ky-list-clear-btn {
            margin-right: 0 !important;
            width: 100% !important;
            min-height: 38px !important;
          }
        }
      `}</style>
    </Dialog>
  );
}

export default CampaignListModal;
